import { ORDER_STATUS } from "../components/shared/my-order-summary-status/selector";

export const CHALLAN_TYPES = {
    PENDING: "pending",
    PAID: "paid"
};

export const CATEGORY_LIST = [{
    title: "Pending Challans",
    type: CHALLAN_TYPES.PENDING
}, {
    title: "Paid Challans",
    type: CHALLAN_TYPES.PAID
}];

export const COURT_TYPES = {
    PHYSICAL: "physical",
    VIRTUAL: "virtual"
};

export const COURT_CONTENT = {
    [COURT_TYPES.PHYSICAL]: {
        title: "How can we settle challans moved to physical court ?",
        description: "Once a challan has been sent to court, the challan holder needs to represent themselves in the respective court hearing and settle the challans."
    },
    [COURT_TYPES.VIRTUAL]: {
        title: "How can we settle challans moved to a virtual court ?",
        description: "Once a challan has moved to virtual court, a challan holder can clear the pending dues by making payment or  choose to contest the case in court."
    }
};

export const CHALLAN_STATES = {
    ONLINE: "Online",
    OFFLINE: "Offline",
    PAID: "Paid",
    UNPAID: "Unpaid",
    FAILED: "Failed"
};

export const CHALLAN_STATES_MAPPING = {
    INFO: [CHALLAN_STATES.ONLINE, CHALLAN_STATES.OFFLINE, ORDER_STATUS.REFUNDED, ORDER_STATUS.REFUND_PENDING],
    SUCCESS: [CHALLAN_STATES.PAID, ORDER_STATUS.FULFILLED],
    PENDING: [CHALLAN_STATES.UNPAID, ORDER_STATUS.INITIATED, ORDER_STATUS.FULFILLMENT_PENDING],
    FAILED: [CHALLAN_STATES.FAILED, ORDER_STATUS.FULFILLMENT_UNSUCCESSFULL]
};

export const PROCESSING_STATUS = {
    PROCESSING: "processing",
    PROCESSED: "processed"
};

export const DEFAULT_SETTLED_CHALLAN_COUNT = "20,000+";

export const SEND_OTP_ENUMS = {
    SENT: "SENT",
    FAILED: "FAILED",
    RETRY: "TOO_EARLY_TO_RETRY",
    OTP_NOT_REQUIRED: "OTP_NOT_REQUIRED"
};

export const VERIFY_OTP_ENUMS = {
    VERIFIED: "VERIFIED",
    VERIFICATION_FAILED: "VERIFICATION_FAILED"
};

export const VARIANT_ENUMS = {
    CONTROL: "CONTROL",
    VARIANT: "VARIANT"
};

export const CHALLAN_TYPE_ENUMS = {
    ONLINE: "Online",
    OFFLINE: "Offline"
};

export const FACTS_COUNT = 10;

export const CHALLAN_STATUS = {
    UNPAID: "Unpaid",
    PAID: "Paid",
    DISPOSED: "Disposed",
    FULFILLED: "FullFilled",
    FULFILLED_ORDER: "FULFILLED",
    FULFILLMENT_NOT_POSSIBLE: "FullFillmentNotPossible",
    REFUND_PENDING: "REFUND_PENDING",
    REFUNDED: "Refunded",
    REFUNDED_ORDER: "REFUNDED",
    PENDING: "Pending",
    FULFILLMENT_PENDING: "FULFILLMENT_PENDING"
};

export const CHALLAN_STATE = {
    OFFLINE: "Offline",
    ONLINE: "Online"
};

export const COURT_TYPE = {
    VIRTUAL: "Virtual",
    PHYSICAL: "Physical"
};

export const COMPUTED_CHALLAN_STATUS = {
    ONLINE: "ONLINE",
    OFFLINE: "OFFLINE",
    VIRTUAL: "VIRTUAL",
    SETTLEMENT_PENDING: "SETTLEMENT_PENDING",
    SETTLED: "SETTLED",
    FAILED: "FAILED",
    REFUND_PENDING: "REFUND_PENDING",
    REFUNDED: "REFUNDED",
    PAID: "PAID"
};

export const REG_NUMBERS_FILTER_PAYLOAD = {
    filterCriteria: { type: "challan" },
    pageDetails: {
        pageSize: 5,
        pageNumber: 0,
        sorting: [{ direction: "DESC", field: "updatedAt" }]
    }
};

export const ORDER_FILTER_PAYLOAD = {
    filterCriteria: { category: "challan" },
    pageDetails: {
        pageSize: 1,
        pageNumber: 0,
        sorting: [{ direction: "DESC", field: "createdAt" }]
    }
};

export const CHALLAN_PAGE_TYPE = {
    STATE_CHALLAN: "STATE_CHALLAN",
    TRAFFIC_CHALLAN: "TRAFFIC_CHALLAN"
};

export const PaidChallanOrderStatus = {
    PENDING: "Pending",
    DISPOSED: "Disposed",
    PAID: "Paid",
    FULFILLED: "FullFilled",
    FULFILLMENT_NOT_DONE: "FullFillmentNotPossible"
};

export const CHALLAN_TYPE = {
    paidChallans: "paidChallans",
    physicalCourtChallans: "physicalCourtChallans",
    virtualCourtChallans: "virtualCourtChallans",
    recentlyAddedChallans: "recentlyAddedChallans"
};

export const OFFLINE_CHALLAN_TAT = "This court challan will be settled in 30-45 days.";
export const ONLINE_CHALLAN_TAT = "This challan will be settled online in 1-3 days.";
